export const csmName = (name: string) => name.replace(/_/g, ':');
